// Wrapper de localStorage a prueba de navegadores que bloquean todo el
// storage del sitio: en ese modo, acceder a localStorage no devuelve null,
// tira un SecurityError síncrono — sin este wrapper, cualquier useState o
// useEffect inicializado desde localStorage (ej. tema) crashea el render de
// la app.
export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Storage bloqueado: la app sigue funcionando sin persistencia.
    }
  },
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // Ignorar
    }
  },
};
